export const enums = {
    competitions: {
        sourceType: {
            BUDGET: 1,
            PAID: 2,
        },
    },
    roles: {
        ADMIN: 'admin',
        WRITER: 'writer',
        OPERATOR: 'operator',
        USER: 'user',
        ORGANIZATION_USER: 'organization_user',
        ORGANIZATION_ADMIN: 'organization_admin',
        ACCREDITATION_AGENCY: 'accreditation_agency',
    },
    adaptive: {
        bodyWidthForTablet: 992,
    },
    newsletterTypes: {
        TEST: 'test',
        SEND: 'send'
    }
};
